<template lang="pug">
  #app
    router-view
    footer-menu
</template>

<script>
import FooterMenu from "@/components/FooterMenu";

export default {
  name: "App",
  components: {
    FooterMenu
  }
}
</script>

<style lang="scss">
@import "node_modules/bootstrap/scss/bootstrap.scss";
@import "node_modules/bootstrap-vue/src/index.scss";

html {
  height: 100%;

  body {
    height: 100%;

    #app {
      padding: 0;
      height: auto;
      min-height: 100%;
      font-family: Avenir, Helvetica, Arial, sans-serif;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      // text-align: center;
      color: #696969;

      .alert {
        margin-bottom: $spacer * .5;
      }
    }
  }
}
</style>
